<template>
  <app-card :colClasses="colClasses">
    <v-card-title>
      <h3>Restore / backup database</h3>
    </v-card-title>
    <v-data-table
      :rows-per-page-items="rowPerPage"
      disable-initial-sort
      :loading="loader"
      :headers="headers"
      :items="items"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-center px-0" style="cursor: pointer">
          <v-icon
            @click="
              folder_name = props.item.name;
              dialog = true;
              type = 'restore';
            "
            small
            class="mr-2"
            >airplanemode_active</v-icon
          >
        </td>
        <td class="text-no-wrap">{{ props.item.name }}</td>
        <td class="text-center">{{ props.item.size }}</td>
        <td class="text-center">{{ props.item.time }}</td>
        <td class="text-center">{{ props.item.month }}</td>
        <!-- <td class="text-center">{{ props.item.date }}</td> -->
      </template>
    </v-data-table>
    <v-btn
      color="primary"
      dark
      block
      @click="
        dialog = true;
        type = 'backup';
      "
    >
      Backup Database
    </v-btn>
    <restore-and-backup-component
      @changeDialogState="dialog = $event"
      :type="type"
      :dialog="dialog"
      :folder_name="folder_name"
      @getBackupFolder="getBackupFolder(), $emit('reloadCollection')"
    ></restore-and-backup-component>
  </app-card>
</template>

<script>
import appConfig from "Constants/AppConfig";
import axios from "axios";
import restoreAndBackupComponent from "Components/Admin/RestoreAndBackupDb";
import api from "../../api";

export default {
  name: "restore-database",
  props: {
    colClasses: String,
  },
  components: {
    restoreAndBackupComponent,
  },
  data() {
    return {
      headers: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Folder",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "Size",
          align: "center",
          sortable: true,
          value: "size",
        },
        { text: "Time", align: "center", sortable: true, value: "time" },
        {
          text: "Month",
          align: "center",
          sortable: true,
          value: "month",
        },
        // {
        // 	text: "Date",
        // 	align: "center",
        // 	sortable: true,
        // 	value: "date"
        // }
      ],
      rowPerPage: [5, 50, 100, { text: "Tất cả", value: -1 }],
      items: [],
      dialog: false,
      folder_name: "",
      type: "",
    };
  },
  created() {
    this.getDbInfo();
    this.getBackupFolder();
  },
  methods: {
    getDbInfo: async function() {
      const data = await api.getDbInfo();
    },
    getBackupFolder: async function() {
      this.loader = true;
      const data = await axios({
        url: appConfig.local_host + "/api/admin/list-backup",
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.$store.state.auth.token,
        },
      });
      this.loader = false;
      this.items = data.data.data.split("\n").map((item) => {
        const data_array = item.replace("  ", " ").split(" ");
        return {
          name: data_array[8],
          size: data_array[4],
          month: data_array[5],
          date: data_array[6],
          time: data_array[7],
        };
      });
      this.items = this.items.slice(1, this.items.length - 1);
    },
  },
};
</script>

<style></style>
